import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterFavoriteIconProps extends SvgIconProps {}
/**
 * component used to display twitter favorite icon in twitter interaction
 * @param props - CcfTwitterFavoriteIconProps
 * @example - <CcfTwitterFavoriteIcon />
 * @returns SVG of twitter favorite icon in twitter interaction
 */
export function CcfTwitterFavoriteIcon(props: CcfTwitterFavoriteIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_twitter_favorite" clip-path="url(#clip-ic_twitter_favorite)">
        <path id="favourite" d="M9.853,1.368h.137c1.368.068,2.326.342,2.326,3.489,0,1.574-3.079,4.858-5.474,6.432C4.721,10.058,1.368,6.842,1.368,4.926c0-3.079,1.642-3.489,2.326-3.558h.137A2.126,2.126,0,0,1,5.542,2.463l1.3,1.574,1.3-1.574S8.895,1.3,9.853,1.368ZM9.853,0A3.08,3.08,0,0,0,6.842,2.053,3.08,3.08,0,0,0,3.832,0H3.626C1.984.068,0,1.3,0,4.926,0,8.621,6.842,13,6.842,13s6.842-4.789,6.842-8.074C13.684,1.3,12.453.137,10.058,0Z" transform="translate(1 2)"/>
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterFavoriteIcon;
